<template>
  <div>
    <vs-row vs-w="12" class="mb-2 mb-4">
      <vs-alert title="Aviso" color="danger" v-if="msg != ''">
        {{ msg }}
      </vs-alert>
    </vs-row>
    <qb-upload
      :showUploadButton="false"
      @on-delete="handleDelete"
      @update-file="handleUpdate"
      accept="application/pdf"
      multiple
      :reset="reset"
    />
  </div>
</template>

<script>
import QbUpload from '@/components/upload/QbUpload.vue'
export default {
  components: {
    QbUpload,
  },
  data() {
    return {
      data: null,
      limit: 10,
      msg: '',
      inputFiles: [],
      files:[],
      reset:false,
    }
  },
  methods: {
    handleDelete(e) {
      let i = this.inputFiles.findIndex((item) => item === e)
      this.inputFiles.splice(i, 1)
      this.validate()
    },
    handleUpdate(e) {
      this.inputFiles = [...this.inputFiles, ...e]
      this.validate()
    },
    validate() {
      this.clear()
      let status = true
      let files = this.inputFiles
      files.map((file) => {
        if (file.type === 'application/pdf') {
            this.files = [...this.files, file]
        }
      })
      if (this.inputFiles.length > this.limit) {
        status = false
        this.msg = `Solo esta permitido un máximo de ${this.limit} archivos.`
      }
      if (this.inputFiles.length == 0) {
        status = false
        this.msg = ''
      }
      this.$emit('update', { status, files: this.files })
    },
    restart() {
      this.reset = !this.reset
      this.inputFiles = []
      this.validate()
    },
    clear() {
      this.msg = ''
      this.files = []
    },
  },
  watch: {
    reset() {
      this.inputFiles = []
    },
  },
}
</script>

<style>
</style>
